import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getPublicPersona } from '../services/apiService';
import ChatPage from './ChatPage';
import PersonaImage from '../components/molecules/PersonaImage';
import CtaSidebar from '../components/chat/CtaSidebar';
import VerificationBadges from '../components/chat/VerificationBadges';
import styles from './PublicPersonaPage.module.css';

const PublicPersonaPage = () => {
  const { username } = useParams();
  const [personaData, setPersonaData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPersona = async () => {
      try {
        setIsLoading(true);
        const data = await getPublicPersona(username);
        setPersonaData(data);
      } catch (e) {
        setError('Persona not found or is not public.');
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPersona();
  }, [username]);

  if (isLoading) {
    return <div className={styles.centeredStatus}>Loading Persona...</div>;
  }

  if (error) {
    return <div className={styles.centeredStatus}>{error}</div>;
  }

  const displayName = personaData.profileName || personaData.personaName;

  return (
    <div className={styles.pageWrapper}>
      <header className={styles.publicHeader}>
        <div className={styles.headerIdentity}>
          <PersonaImage
            personaId={personaData.personaId}
            alt={personaData.publicName || personaData.personaName}
            className={styles.headerAvatar}
            isOwner={false}
            username={personaData.username}
          />
          <div className={styles.headerInfo}>
            <h1 className={styles.personaName}>{displayName}</h1>
            <p className={styles.personaSummary}>{personaData.summary}</p>
          </div>
        </div>
        <VerificationBadges
          verificationStatus={personaData.verificationStatus}
          planTier={personaData.planTier}
        />
      </header>
      <main className={styles.contentLayout}>
        {personaData?.ctas?.length > 0 && (
          <CtaSidebar ctas={personaData.ctas} />
        )}

        {personaData && (
          <ChatPage mode="public" publicPersonaData={personaData} />
        )}
      </main>
      <footer className={styles.publicFooter}>
        Powered by{' '}
        <Link to="/" className={styles.brandLink}>
          Ego Protocol
        </Link>
      </footer>
    </div>
  );
};

export default PublicPersonaPage;
